import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpDebugInterceptor } from './http-debug-interceptor';
import { HttpExceptionMappingInterceptor } from './http-exception-mapping-interceptor';
import { SystemEventsInterceptor } from './system-events-interceptor';
import { UzurvAuthTokenHttpInterceptor } from './uzurv-auth-token-http-interceptor';
import { UzurvDataProcessorHttpInterceptor } from './uzurv-data-processor-http-interceptor';

@NgModule({
  imports: [CommonModule]
})
export class ClaraHttpInterceptorsModule {
  static forRoot(): ModuleWithProviders<ClaraHttpInterceptorsModule> {
    return {
      ngModule: ClaraHttpInterceptorsModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpExceptionMappingInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: UzurvAuthTokenHttpInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpDebugInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SystemEventsInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: UzurvDataProcessorHttpInterceptor,
          multi: true
        }
      ]
    };
  }
}
